import { Controller } from "@hotwired/stimulus"

// Переключение вида: таблица ↔ карточки на странице Sources
// data-controller="dae20--sources-view-toggle"
export default class extends Controller {
  static targets = ["grid", "table", "btnGrid", "btnTable"]
  static values = { default: { type: String, default: "table" } }

  STORAGE_KEY = "dae20_sources_view"

  connect() {
    this.mode = localStorage.getItem(this.STORAGE_KEY) || this.defaultValue
    this.apply()
  }

  showGrid() {
    this.mode = "grid"
    this.persist()
    this.apply()
  }

  showTable() {
    this.mode = "table"
    this.persist()
    this.apply()
  }

  // private

  apply() {
    const isTable = this.mode === "table"

    if (this.hasGridTarget) {
      this.gridTarget.classList.toggle("hidden", isTable)
    }
    if (this.hasTableTarget) {
      this.tableTarget.classList.toggle("hidden", !isTable)
    }

    // Активная кнопка
    if (this.hasBtnGridTarget) {
      this.btnGridTarget.classList.toggle("bg-blue-100", !isTable)
      this.btnGridTarget.classList.toggle("text-blue-700", !isTable)
      this.btnGridTarget.classList.toggle("text-gray-400", isTable)
    }
    if (this.hasBtnTableTarget) {
      this.btnTableTarget.classList.toggle("bg-blue-100", isTable)
      this.btnTableTarget.classList.toggle("text-blue-700", isTable)
      this.btnTableTarget.classList.toggle("text-gray-400", !isTable)
    }
  }

  persist() {
    localStorage.setItem(this.STORAGE_KEY, this.mode)
  }
}
